import { Button, Col, Container, Form, Row } from "react-bootstrap";
import {
  ModalSweetAlert,
  Notificacion,
} from "@components/general/Alertas/Alertas";
import React, { useEffect } from "react";
import {
  getSeccionesByCodigoCurso,
  updateReorderSecciones,
} from "@helpers/httpRequests/httpRequestsSecciones/httpRequestsSecciones";
import SeccionCurso from "./SeccionCurso";
import TitleDashboard from "@components/general/Titles/TitleDashboard";
import { getCursos } from "@helpers/httpRequests/httpRequestsCursos/httpRequestsCursos";
import { useState } from "react";
import codigoCursosUsuarioInvitado from "@helpers/cursos/codigosCursosUsuarioInvitado";
import { closestCorners, DndContext, DragOverlay, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { SortableItem } from "./SortableItem";
import { Item } from "./Item";

const getDragnDropListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#e3e3e3" : "#FFF",
  padding: 15,
  // width: 250
});

const getDragnDropItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: 10,
  // margin: `0 0 ${8}px 0`,
  background: isDragging ? "#FFF" : "transparent",
  ...draggableStyle,
});

const TableGestionContenido = () => {
  const [cursos, setCursos] = useState([]);

  const [secciones, setSecciones] = useState([]);

  const [recoverySecciones, setRecoverySecciones] = useState([]);

  const [editarSecciones, setEditarSecciones] = useState(false);

   const [activeId, setActiveId] = useState(null);
  const [items, setItems] = useState([1,2,3]);

  const handleSeleccionCurso = async ({ target }) => {
    try {
      if (target.value === "") {
        return Notificacion("info", "Elige un curso");
      }

      let { data: secciones } = await getSeccionesByCodigoCurso(target.value);

      const ordenadas = [...secciones].sort(
      (a, b) => Number(a.nivel) - Number(b.nivel) // ó +a.nivel - +b.nivel
      );
    
      if (!Array.isArray(ordenadas)) {
        secciones = [ordenadas];
      }

      setSecciones(ordenadas);

      setRecoverySecciones(ordenadas);
    } catch (error) {
      console.log("Error al consultar las secciones del curso ", error);

      setSecciones([]);
    }
  };

  useEffect(() => {
    const consultarCursos = async () => {
      try {
        const { data: cursos } = await getCursos();

        setCursos(cursos);
      } catch (error) {
        console.log("Error al obtener los cursos disponibles: ", error);

        Notificacion("error", "No se pudieron obtener los cursos");
      }
    };

    consultarCursos();
  }, []);

  const handleEditSecciones = () => {
    setEditarSecciones(true);
  };

  const handleCancelEditSecciones = () => {
    setSecciones(recoverySecciones);

    setEditarSecciones(false);
  };

   function handleDragStart(event) {
    const {active} = event;
    
    setActiveId(active.id);
  }

  const handleDragDropEnd = (result) => {

    const {active, over} = result;
    
    if (active.id !== over.id) {

    let seccionesReordenadas = [];

    const oldIndex = secciones.indexOf(secciones[active.id - 1]);
    const newIndex = secciones.indexOf(secciones[over.id - 1]);
    
    seccionesReordenadas = arrayMove(secciones, oldIndex, newIndex);
    
    seccionesReordenadas.forEach((seccion, idx) => {
      const nuevoNivel = idx + 1;

      const nuevoNivelFormateado =
        nuevoNivel < 10 ? `0${nuevoNivel}` : nuevoNivel;

      seccionesReordenadas[idx] = {
        ...seccion,
        nivel: nuevoNivelFormateado,
      };
    });

    setSecciones(seccionesReordenadas);
    }
  };

  const handleGuardarReorden = async () => {
    try {
      const isConfirmed = await ModalSweetAlert({
        title: "¿Estás seguro que deseas reordenar las secciones?",
        showCancelButton: true,
        confirmButtonColor: "#007bff",
        confirmButtonText: "Sí, reordenar",
        cancelButtonText: "No, cancelar",
      });

      if (!isConfirmed) {
        return;
      }

      await updateReorderSecciones(secciones);

      setEditarSecciones(false);

      Notificacion("success", "Las secciones se reordenaron con éxito");
    } catch (error) {
      console.log("Error al guardar el reorden: ", error);

      Notificacion("error", "No se pudieron reordenar las secciones");
    }
  };
 
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );


  return (
    <Container fluid className="p-0 mb-3">
      <Row>
        <Col>
          <Form.Group as={Col} controlId="text" className="mb-4">
            <Form.Label>Elige un curso</Form.Label>

            <Form.Control as={"select"} onChange={handleSeleccionCurso}>
              <option value="">Elige un curso</option>

              {cursos.map((curso, idx) => (
                <option value={curso.codigoCurso} key={idx}>
                  {curso.nombre} - {curso.codigoCurso}{" "}
                  {codigoCursosUsuarioInvitado.find(
                    (invitado) => invitado.codigoInvitado === curso.codigoCurso
                  ) !== undefined && "- Usuarios Invitados"}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>

      {secciones.length > 0 ? (
        <>
          <Row>
            <Col align="left">
              <TitleDashboard title="Secciones" />
            </Col>

            <Col align="right">
              {!editarSecciones && (
                <Button variant="primary" onClick={handleEditSecciones}>
                  Cambiar orden de las secciones
                </Button>
              )}

              {editarSecciones && (
                <>
                  <Button
                    className="me-2"
                    variant="success"
                    onClick={handleGuardarReorden}
                  >
                    Guardar
                  </Button>

                  <Button
                    className="me-2"
                    variant="danger"
                    onClick={handleCancelEditSecciones}
                  >
                    Cancelar
                  </Button>
                </>
              )}
            </Col>
          </Row>

          {editarSecciones && (
            <h5>
              Da clic y arrastra la sección al lugar donde deseas reordenarla
            </h5>
          )}

          <Row className="mt-3">
            <Col>
              {editarSecciones ? (
                <DndContext sensors={sensors} collisionDetection={closestCorners} onDragStart={handleDragStart} onDragEnd={handleDragDropEnd}>
                  <SortableContext items={secciones} strategy={verticalListSortingStrategy}>
                    {secciones.map((seccion, idx) => <SortableItem 
                    key={idx + 1} 
                    id={idx + 1} 
                    idx={idx} 
                    seccionInfo={seccion}
                    editarSecciones={editarSecciones}
                    codigoSeccion={seccion.codigoSeccion} 
                    />)}
                  </SortableContext>
                  <DragOverlay>
                    {activeId ? <Item seccionInfo={secciones[activeId - 1]} id={activeId} /> : null}
                  </DragOverlay>
                </DndContext>
              ) : (
                <>
                  {secciones.map((seccion, idx) => (
                    <SeccionCurso
                      key={idx + 1}
                      codigoSeccion={seccion.codigoSeccion}
                      nombre={seccion.nombre}
                      idx={idx}
                    />
                  ))}
                </>
              )}
            </Col>
          </Row>
        </>
      ) : (
        <h5>No hay secciones en este curso</h5>
      )}
    </Container>
  );
};

export default TableGestionContenido;
